/**
 * Method used in order to render a custom promotional footer.
 *
 * @returns {HTMLElement}
 */
export function renderPromotionalFooter() {
    return null;
}
